import { RouterProvider } from 'react-router-dom';
import { appRouter } from './Router';
import { ClientStorage } from './storage/ClientStorage';
import { Toaster } from 'sonner';
import { LoadScript } from '@react-google-maps/api';
import Loading from './components/Loading';
import { Suspense, useEffect, useState } from 'react';
import { socket } from './services/socket_io';
import { AppStorage } from './storage/AppStorage';
import { useVersionCheck } from './hooks/useVersionCheck';

// Definir libraries fuera del componente para evitar recargas innecesarias
const GOOGLE_MAPS_LIBRARIES: ("places")[] = ['places'];

export function App() {

  useVersionCheck();

  const [appStorage, setAppStorage] = useState({
    connected: true,
  });

  useEffect(() => {
    const handleDisconnect = () => {
      setAppStorage(prevState => ({ ...prevState, connected: false }));
    };

    const handleConnect = () => {
      setAppStorage(prevState => ({ ...prevState, connected: true }));
    };

    socket.on('disconnect', handleDisconnect);
    socket.on('connect', handleConnect);

    if (!socket.connected) {
      socket.connect();
    } else {
      handleConnect();
    }

    return () => {
      socket.off('disconnect', handleDisconnect);
      socket.off('connect', handleConnect);
    };
  }, []);

  return (
    <ClientStorage>
      <LoadScript
        googleMapsApiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
        libraries={GOOGLE_MAPS_LIBRARIES}
        loadingElement={<Loading />}
      >
        <Toaster 
          richColors 
          position="top-right" 
          closeButton 
          toastOptions={{
            className: 'text-sm md:text-base',
            style: {
              padding: '12px 16px',
              minHeight: '48px',
            },
          }}
          className="md:top-4 md:right-4 top-2 right-2"
        />
        <AppStorage.Provider value={appStorage}>

          <Suspense fallback={<Loading />}>
            <RouterProvider router={appRouter} />
          </Suspense>
        </AppStorage.Provider>
      </LoadScript>
    </ClientStorage>
  );
}
